const { getElements } = window.BAO.Utils

export class ProductCompare extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link', 'column']
  }

  constructor () {
    super()

    this.isTicking = false

    this.handleIntersection = this.handleIntersection.bind(this)
    this.observer = new IntersectionObserver(this.handleIntersection)
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach(link => {
      this.listeners.add(link, 'mouseover', event =>
        this.setActiveLink(event.currentTarget),
      )

      this.listeners.add(link, 'focus', event =>
        this.setActiveLink(event.currentTarget),
      )
    })

    this.observableRegions.forEach(region => {
      this.observer.observe(region)
    })
  }

  /** @param {IntersectionObserverEntry[]} entries */
  handleIntersection (entries) {
    const firstVisibleRegion = entries.find(entry => entry.isIntersecting)
    if (!firstVisibleRegion) {
      return
    }

    const { id } = firstVisibleRegion.target
    const relatedLink = this.els.link.elements.find(
      link => link.hash === `#${id}`,
    )
    this.setActiveLink(relatedLink)
  }

  /** @param {HTMLAnchorElement} link */
  setActiveLink (link) {
    this.els.link.elements.forEach(element => {
      element.classList.toggle(this.dataset.activeClass, link === element)
    })
  }

  /** @returns {HTMLElement[]} */
  get observableRegions () {
    const selector = this.els.column.selector
    return getElements(selector, { context: this })
  }
}

if (!customElements.get('product-compare')) {
  customElements.define('product-compare', ProductCompare)
}
